export enum AdRoutes {
  routePlanner = "/route-planner/:date",
  createTempRouteSequence = "/route-planner/:date/create-temp-route/sequence",
  createTempRouteDetails = "/route-planner/:date/create-temp-route/details",

  notifications = "/notifications",
  addNotification = "/notifications/add",

  addNotificationRecipientsCustom = "/notifications/:notificationId/recipients/custom",
  managePendingRecipients = "/notifications/pending/recipients",
  notificationDetails = "/notifications/:notificationId",
  notificationServiceAlertDetails = "/notifications/serviceAlert/:notificationId",
  notificationRecipients = "/notifications/:notificationId/recipients",
  editEventNotification = "/notifications/eventNotification/:notificationId",

  // Leads (CRM)
  leads = "/leads",
  leadAdd = "/leads/add",
  leadDetail = "/leads/:leadId",
  leadConvert = "/leads/:leadId/convert",

  customer = "/customer",
  customerDetail = "/customer/:customerId",
  customerDetailAddress = "/customer/:customerId/:addressId",
  addCustomerCombo = "/customer/add-customer-combo",
  // Might not be the best but you can not create an address
  // without a customer id ever + we still want to highlight the sidebar
  addAddress = "/customer/:customerId/new-address",

  snowReports = "/snow-reports",
  snowReportsDetail = "/snow-reports/:reportId",
  snowReportsCreate = "/snow-reports/add-report",
  // Auth router - can be broken out ...
  login = "/login",
  forgotPassword = "/forgot-password",
  forgotPasswordComplete = "/forgot-password-complete",
  updatePassword = "/update-password",
  acceptInvite = "/accept-invite",
  setupReplyEmail = "/setup-reply-email",
  settings = "/settings",

  // Region management
  regionManagement = "/region-management",
  createSequence = "/region-management/create-sequence",
  createRegionDetails = "/region-management/region-details",
  editRegionDetails = "/region-management/region-details/:regionId",
  resequenceRoute = "/region-management/re-sequence/:regionId",
  sequenceUnassigned = "/region-management/add-unassigned-to-region/:regionId",
  regionDetails = "/region-management/:regionId",

  // Fleet Management
  fleetManagement = "/fleet-management",
  addVehicle = "/fleet-management/add",
  editVehicle = "/fleet-management/:vehicleId/edit",
  vehicleTypes = "/vehicle-types",
  addVehicleType = "/vehicle-types/add",
  editVehicleType = "/vehicle-types/:typeId/edit",

  // Driver Management
  driverManagement = "/driver-management",
  addDriver = "/driver-management/add",
  editDriver = "/driver-management/:driverId/edit",
  organizations = "/organizations",
  addOrganization = "/organizations/add",
  organizationDetail = "/organizations/:organizationId",
  editOrganization = "/organizations/:organizationId/edit",
}
